const ready = (instantiate) => {
  // Scripts can evaluate after DOMContentLoaded has already fired (e.g. consent
  // tools re-enabling blocked scripts) — run immediately if the DOM is parsed.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      instantiate();
    });
  } else {
    instantiate();
  }
};

const onShopifySectionLoad = (run) => {
  const shopifyEvents = [
    'shopify:section:load'
  ];
  shopifyEvents.forEach((event) => {
    document.addEventListener(event, () => run(event));
  });
};

export {
  ready,
  onShopifySectionLoad
};
